
import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@mui/material";

function OceanTableMapping({ tableData,firstAndLast }: { tableData: any[],firstAndLast:any }) {
    return <div className="listEventsTableResponsiive">
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell>Port</TableCell>
                    <TableCell>Country </TableCell>
                    <TableCell>Milestone</TableCell>
                    <TableCell>Milestone Type</TableCell>
                    <TableCell>Transport Type</TableCell>
                    <TableCell>Port Type</TableCell>
                    <TableCell>Date</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>


                {firstAndLast.first.filter((ele:any)=>ele.status).map(
                    (milestone: any, idx: any) => (
                        <TableRow key={idx}>
                            <TableCell>{""}</TableCell>
                            <TableCell>{milestone?.country || ""}</TableCell>
                            <TableCell>{milestone?.name || ""}</TableCell>
                            <TableCell>{milestone?.milestoneType||""}</TableCell>
                            <TableCell>{milestone?.transportType ||""}</TableCell>
                            <TableCell>{milestone?.portType || ""}</TableCell>
                            <TableCell>{milestone?.date || ""}</TableCell>
                        </TableRow>
                    )
                )}
                {tableData.map(
                    (milestone: any, idx: any) => (
                        <TableRow key={idx}>
                            <TableCell>
                                {milestone.portName || ""}
                            </TableCell>
                            <TableCell>
                                {milestone.country || ""}
                            </TableCell>
                            <TableCell>
                                {milestone.milestone || ""}
                            </TableCell>
                            <TableCell>
                                Main Carriage
                            </TableCell>
                            <TableCell>
                                {milestone.transportType ||
                                    ""}
                            </TableCell>
                            <TableCell>
                                {milestone.portType || ""}
                            </TableCell>
                            <TableCell>
                                {milestone.date || ""}
                            </TableCell>
                        </TableRow>
                    )
                )}
                {firstAndLast.last.filter((ele:any)=>ele.status).map(
                    (milestone: any, idx: any) => (
                        <TableRow key={idx}>
                            <TableCell>{""}</TableCell>
                            <TableCell>{milestone?.country || ""}</TableCell>
                            <TableCell>{milestone?.name || ""}</TableCell>
                            <TableCell>{milestone?.milestoneType||""}</TableCell>
                            <TableCell>{milestone?.transportType ||""}</TableCell>
                            <TableCell>{milestone?.portType || ""}</TableCell>
                            <TableCell>{milestone?.date || ""}</TableCell>
                        </TableRow>
                    )
                )}
            </TableBody>
        </Table>
    </div>
}

export default OceanTableMapping;